import React from "react"
import "./RestartPapersField.style.scss"

interface RestartPapersFieldProps {
  checked: boolean
  paperCount: number
  disabled?: boolean
  onChange: (checked: boolean) => void
}

const RestartPapersField = ({
  checked,
  paperCount,
  disabled = false,
  onChange,
}: RestartPapersFieldProps) => (
  <label className={`restart-papers-field${checked ? " is-on" : ""}`}>
    <input
      type="checkbox"
      name="restartPapers"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span>
      <strong>Restart selected papers from scratch</strong>
      <span className="restart-papers-field__help">
        {paperCount === 1
          ? "Clears the existing attempt on this paper so the goal starts at 0%. You'll sit it again."
          : `Clears existing attempts on ${paperCount} papers so this goal starts at 0%. You'll sit them again.`}
      </span>
    </span>
  </label>
)

export default RestartPapersField
